

// src/spinnaxBase/data/locations.ts

export interface Skatepark {
  name: string;
  address: string;
  type: 'Indoor' | 'Outdoor';
}

export interface City {
  name: string;
  population?: number;
  skateparks: Skatepark[];
}

export interface Country {
  code: string;
  name: string;
  cities: City[];
}

export interface Continent {
  code: string;
  name: string;
  countries: Country[];
}

export const continents: Continent[] = [
  {
    code: 'EUR',
    name: 'EUROPE',
    countries: [
      {
        code: 'AL',
        name: 'ALBANIA',
        cities: []
      },
      {
        code: 'AD',
        name: 'ANDORRA',
        cities: []
      },
      {
        code: 'AT',
        name: 'AUSTRIA',
        cities: []
      },
      {
        code: 'BY',
        name: 'BELARUS',
        cities: []
      },
      {
        code: 'BE',
        name: 'BELGIUM',
        cities: []
      },
      {
        code: 'BA',
        name: 'BOSNIA_AND_HERZEGOVINA',
        cities: []
      },
      {
        code: 'BG',
        name: 'BULGARIA',
        cities: []
      },
      {
        code: 'HR',
        name: 'CROATIA',
        cities: []
      },
      {
        code: 'CZ',
        name: 'CZECH_REPUBLIC',
        cities: []
      },
      {
        code: 'DK',
        name: 'DENMARK',
        cities: []
      },
      {
        code: 'EE',
        name: 'ESTONIA',
        cities: []
      },
      {
        code: 'FO',
        name: 'FAROE_ISLANDS',
        cities: []
      },
      {
        code: 'FI',
        name: 'FINLAND',
        cities: []
      },
      {
        code: 'MK',
        name: 'FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA',
        cities: []
      },
      {
        code: 'FR',
        name: 'FRANCE',
        cities: [
          { 
            name: 'Paris', 
            population: 2148271,
            skateparks: [
              { name: 'Le Dome', address: '54 Boulevard Davout, 75020', type: 'Indoor' },
              { name: 'Cosanostra Skatepark', address: '12 Rue Carpentier, 93200', type: 'Indoor' },
              { name: 'Trocadéro', address: 'Place du Trocadéro, 75016', type: 'Outdoor' }
            ]
          },
          { 
            name: 'Marseille', 
            population: 861635,
            skateparks: [
              { name: 'Skatepark du Prado', address: 'Parc Borély, 13008', type: 'Outdoor' },
              { name: 'La Friche', address: '41 Rue Jobin, 13003', type: 'Indoor' }
            ]
          },
          { 
            name: 'Lyon', 
            population: 513275,
            skateparks: [
              { name: 'Skatepark de la Feyssine', address: 'Quai Claude Bernard, 69007', type: 'Outdoor' },
              { name: 'La Halle Tony Garnier', address: 'Place Charles Blanc, 69007', type: 'Indoor' }
            ]
          }
        ]
      },
      {
        code: 'DE',
        name: 'GERMANY',
        cities: [
          { 
            name: 'Berlin', 
            population: 3669495,
            skateparks: [
              { name: 'Nike SB Shelter', address: 'Revaler Str. 99, 10245', type: 'Indoor' },
              { name: 'Gleisdreieck', address: 'Möckernstraße 26, 10963', type: 'Outdoor' },
              { name: 'Skatehalle Berlin', address: 'Revaler Str. 99, 10245', type: 'Indoor' }
            ]
          },
          { 
            name: 'Hamburg', 
            population: 1841179,
            skateparks: [
              { name: 'I-Punkt Skateland', address: 'Rübenkamp 226, 22307', type: 'Indoor' },
              { name: 'Wilhelmsburg Skatepark', address: 'Rotenhäuser Str. 100, 21107', type: 'Outdoor' },
              { name: 'North Brigade', address: 'Große Bergstraße 264, 22767', type: 'Indoor' }
            ]
          },
          { 
            name: 'München', 
            population: 1471508,
            skateparks: [
              { name: 'Hirschgarten Skatepark', address: 'De-la-Paz-Straße 4, 80639', type: 'Outdoor' },
              { name: 'FreihamX', address: 'Hans-Clarin-Weg 10, 81247', type: 'Indoor' },
              { name: 'Munich Olympic Skatepark', address: 'Spiridon-Louis-Ring 21, 80809', type: 'Outdoor' }
            ]
          }
        ]
      },
      {
        code: 'GI',
        name: 'GIBRALTAR',
        cities: []
      },
      {
        code: 'GR',
        name: 'GREECE',
        cities: []
      },
      {
        code: 'GG',
        name: 'GUERNSEY',
        cities: []
      },
      {
        code: 'HU',
        name: 'HUNGARY',
        cities: []
      },
      {
        code: 'IS',
        name: 'ICELAND',
        cities: []
      },
      {
        code: 'IE',
        name: 'IRELAND',
        cities: []
      },
      {
        code: 'IM',
        name: 'ISLE_OF_MAN',
        cities: []
      },
      {
        code: 'IT',
        name: 'ITALY',
        cities: []
      },
      {
        code: 'JE',
        name: 'JERSEY',
        cities: []
      },
      {
        code: 'LV',
        name: 'LATVIA',
        cities: []
      },
      {
        code: 'LI',
        name: 'LIECHTENSTEIN',
        cities: []
      },
      {
        code: 'LT',
        name: 'LITHUANIA',
        cities: []
      },
      {
        code: 'LU',
        name: 'LUXEMBOURG',
        cities: []
      },
      {
        code: 'MT',
        name: 'MALTA',
        cities: []
      },
      {
        code: 'MD',
        name: 'MOLDOVA',
        cities: []
      },
      {
        code: 'MC',
        name: 'MONACO',
        cities: []
      },
      {
        code: 'ME',
        name: 'MONTENEGRO',
        cities: []
      },
      {
        code: 'NL',
        name: 'NETHERLANDS',
        cities: []
      },
      {
        code: 'NO',
        name: 'NORWAY',
        cities: []
      },
      {
        code: 'PL',
        name: 'POLAND',
        cities: []
      },
      {
        code: 'PT',
        name: 'PORTUGAL',
        cities: []
      },
      {
        code: 'RO',
        name: 'ROMANIA',
        cities: []
      },
      {
        code: 'RU',
        name: 'RUSSIAN_FEDERATION',
        cities: []
      },
      {
        code: 'SM',
        name: 'SAN_MARINO',
        cities: []
      },
      {
        code: 'RS',
        name: 'SERBIA',
        cities: []
      },
      {
        code: 'SK',
        name: 'SLOVAKIA',
        cities: []
      },
      {
        code: 'SI',
        name: 'SLOVENIA',
        cities: []
      },
      {
        code: 'ES',
        name: 'SPAIN',
        cities: []
      },
      {
        code: 'SJ',
        name: 'SVALBARD_AND_JAN_MAYEN',
        cities: []
      },
      {
        code: 'SE',
        name: 'SWEDEN',
        cities: []
      },
      {
        code: 'CH',
        name: 'SWITZERLAND',
        cities: []
      },
      {
        code: 'UA',
        name: 'UKRAINE',
        cities: []
      },
      {
        code: 'GB',
        name: 'UNITED_KINGDOM',
        cities: []
      },
      {
        code: 'VA',
        name: 'VATICAN_CITY_STATE',
        cities: []
      },
      {
        code: 'AX',
        name: 'ÅLAND_ISLANDS',
        cities: []
      },
    ],
  },
  {
    code: 'NAM',
    name: 'NORTH_AMERICA',
    countries: [
      {
        code: 'AI',
        name: 'ANGUILLA',
        cities: []
      },
      {
        code: 'AG',
        name: 'ANTIGUA_AND_BARBUDA',
        cities: []
      },
      {
        code: 'AW',
        name: 'ARUBA',
        cities: []
      },
      {
        code: 'BS',
        name: 'BAHAMAS',
        cities: []
      },
      {
        code: 'BB',
        name: 'BARBADOS',
        cities: []
      },
      {
        code: 'BZ',
        name: 'BELIZE',
        cities: []
      },
      {
        code: 'BM',
        name: 'BERMUDA',
        cities: []
      },
      {
        code: 'CA',
        name: 'CANADA',
        cities: []
      },
      {
        code: 'BQ',
        name: 'CARIBBEAN_NETHERLANDS',
        cities: []
      },
      {
        code: 'KY',
        name: 'CAYMAN_ISLANDS',
        cities: []
      },
      {
        code: 'CR',
        name: 'COSTA_RICA',
        cities: []
      },
      {
        code: 'CU',
        name: 'CUBA',
        cities: []
      },
      {
        code: 'CW',
        name: 'CURAÇAO',
        cities: []
      },
      {
        code: 'DM',
        name: 'DOMINICA',
        cities: []
      },
      {
        code: 'DO',
        name: 'DOMINICAN_REPUBLIC',
        cities: []
      },
      {
        code: 'SV',
        name: 'EL_SALVADOR',
        cities: []
      },
      {
        code: 'GL',
        name: 'GREENLAND',
        cities: []
      },
      {
        code: 'GD',
        name: 'GRENADA',
        cities: []
      },
      {
        code: 'GP',
        name: 'GUADELOUPE',
        cities: []
      },
      {
        code: 'GT',
        name: 'GUATEMALA',
        cities: []
      },
      {
        code: 'HT',
        name: 'HAITI',
        cities: []
      },
      {
        code: 'HN',
        name: 'HONDURAS',
        cities: []
      },
      {
        code: 'JM',
        name: 'JAMAICA',
        cities: []
      },
      {
        code: 'MQ',
        name: 'MARTINIQUE',
        cities: []
      },
      {
        code: 'MX',
        name: 'MEXICO',
        cities: []
      },
      {
        code: 'MS',
        name: 'MONTSERRAT',
        cities: []
      },
      {
        code: 'NI',
        name: 'NICARAGUA',
        cities: []
      },
      {
        code: 'PA',
        name: 'PANAMA',
        cities: []
      },
      {
        code: 'PR',
        name: 'PUERTO_RICO',
        cities: []
      },
      {
        code: 'BL',
        name: 'SAINT_BARTHÉLEMY',
        cities: []
      },
      {
        code: 'KN',
        name: 'SAINT_KITTS_AND_NEVIS',
        cities: []
      },
      {
        code: 'LC',
        name: 'SAINT_LUCIA',
        cities: []
      },
      {
        code: 'MF',
        name: 'SAINT_MARTIN_(FRENCH_PART)',
        cities: []
      },
      {
        code: 'PM',
        name: 'SAINT_PIERRE_AND_MIQUELON',
        cities: []
      },
      {
        code: 'VC',
        name: 'SAINT_VINCENT_AND_THE_GRENADINES',
        cities: []
      },
      {
        code: 'SX',
        name: 'SINT_MAARTEN',
        cities: []
      },
      {
        code: 'TT',
        name: 'TRINIDAD_AND_TOBAGO',
        cities: []
      },
      {
        code: 'TC',
        name: 'TURKS_AND_CAICOS_ISLANDS',
        cities: []
      },
      {
        code: 'US',
        name: 'UNITED_STATES',
        cities: []
      },
      {
        code: 'VG',
        name: 'VIRGIN_ISLANDS,_BRITISH',
        cities: []
      },
      {
        code: 'VI',
        name: 'VIRGIN_ISLANDS,_U.S.',
        cities: []
      },
    ],
  },
  {
    code: 'ASI',
    name: 'ASIA',
    countries: [
      {
        code: 'AF',
        name: 'AFGHANISTAN',
        cities: []
      },
      {
        code: 'AM',
        name: 'ARMENIA',
        cities: []
      },
      {
        code: 'AZ',
        name: 'AZERBAIJAN',
        cities: []
      },
      {
        code: 'BH',
        name: 'BAHRAIN',
        cities: []
      },
      {
        code: 'BD',
        name: 'BANGLADESH',
        cities: []
      },
      {
        code: 'BT',
        name: 'BHUTAN',
        cities: []
      },
      {
        code: 'BN',
        name: 'BRUNEI_DARUSSALAM',
        cities: []
      },
      {
        code: 'KH',
        name: 'CAMBODIA',
        cities: []
      },
      {
        code: 'CN',
        name: 'CHINA',
        cities: []
      },
      {
        code: 'CY',
        name: 'CYPRUS',
        cities: []
      },
      {
        code: 'GE',
        name: 'GEORGIA',
        cities: []
      },
      {
        code: 'HK',
        name: 'HONG_KONG',
        cities: []
      },
      {
        code: 'IN',
        name: 'INDIA',
        cities: []
      },
      {
        code: 'ID',
        name: 'INDONESIA',
        cities: []
      },
      {
        code: 'IR',
        name: 'IRAN',
        cities: []
      },
      {
        code: 'IQ',
        name: 'IRAQ',
        cities: []
      },
      {
        code: 'IL',
        name: 'ISRAEL',
        cities: []
      },
      {
        code: 'JP',
        name: 'JAPAN',
        cities: []
      },
      {
        code: 'JO',
        name: 'JORDAN',
        cities: []
      },
      {
        code: 'KZ',
        name: 'KAZAKHSTAN',
        cities: []
      },
      {
        code: 'KW',
        name: 'KUWAIT',
        cities: []
      },
      {
        code: 'KG',
        name: 'KYRGYZSTAN',
        cities: []
      },
      {
        code: 'LA',
        name: 'LAOS',
        cities: []
      },
      {
        code: 'LB',
        name: 'LEBANON',
        cities: []
      },
      {
        code: 'MO',
        name: 'MACAO',
        cities: []
      },
      {
        code: 'MY',
        name: 'MALAYSIA',
        cities: []
      },
      {
        code: 'MV',
        name: 'MALDIVES',
        cities: []
      },
      {
        code: 'MN',
        name: 'MONGOLIA',
        cities: []
      },
      {
        code: 'MM',
        name: 'MYANMAR',
        cities: []
      },
      {
        code: 'NP',
        name: 'NEPAL',
        cities: []
      },
      {
        code: 'KP',
        name: 'NORTH_KOREA',
        cities: []
      },
      {
        code: 'OM',
        name: 'OMAN',
        cities: []
      },
      {
        code: 'PK',
        name: 'PAKISTAN',
        cities: []
      },
      {
        code: 'PS',
        name: 'PALESTINIAN_TERRITORY',
        cities: []
      },
      {
        code: 'PH',
        name: 'PHILIPPINES',
        cities: []
      },
      {
        code: 'QA',
        name: 'QATAR',
        cities: []
      },
      {
        code: 'SA',
        name: 'SAUDI_ARABIA',
        cities: []
      },
      {
        code: 'SG',
        name: 'SINGAPORE',
        cities: []
      },
      {
        code: 'KR',
        name: 'SOUTH_KOREA',
        cities: []
      },
      {
        code: 'LK',
        name: 'SRI_LANKA',
        cities: []
      },
      {
        code: 'SY',
        name: 'SYRIA',
        cities: []
      },
      {
        code: 'TW',
        name: 'TAIWAN_(REPUBLIC_OF_CHINA)',
        cities: []
      },
      {
        code: 'TJ',
        name: 'TAJIKISTAN',
        cities: []
      },
      {
        code: 'TH',
        name: 'THAILAND',
        cities: []
      },
      {
        code: 'TL',
        name: 'TIMOR-LESTE',
        cities: []
      },
      {
        code: 'TR',
        name: 'TURKEY',
        cities: []
      },
      {
        code: 'TM',
        name: 'TURKMENISTAN',
        cities: []
      },
      {
        code: 'AE',
        name: 'UNITED_ARAB_EMIRATES',
        cities: []
      },
      {
        code: 'UZ',
        name: 'UZBEKISTAN',
        cities: []
      },
      {
        code: 'VN',
        name: 'VIET_NAM',
        cities: []
      },
      {
        code: 'YE',
        name: 'YEMEN',
        cities: []
      },
    ],
  },
  {
    code: 'AUS',
    name: 'OCEANIA',
    countries: [
      {
        code: 'AS',
        name: 'AMERICAN_SAMOA',
        cities: []
      },
      {
        code: 'AU',
        name: 'AUSTRALIA',
        cities: []
      },
      {
        code: 'IO',
        name: 'BRITISH_INDIAN_OCEAN_TERRITORY',
        cities: []
      },
      {
        code: 'CX',
        name: 'CHRISTMAS_ISLAND',
        cities: []
      },
      {
        code: 'CC',
        name: 'COCOS_(KEELING)_ISLANDS',
        cities: []
      },
      {
        code: 'CK',
        name: 'COOK_ISLANDS',
        cities: []
      },
      {
        code: 'FJ',
        name: 'FIJI',
        cities: []
      },
      {
        code: 'PF',
        name: 'FRENCH_POLYNESIA',
        cities: []
      },
      {
        code: 'GU',
        name: 'GUAM',
        cities: []
      },
      {
        code: 'KI',
        name: 'KIRIBATI',
        cities: []
      },
      {
        code: 'MH',
        name: 'MARSHALL_ISLANDS',
        cities: []
      },
      {
        code: 'FM',
        name: 'MICRONESIA,_FEDERATED_STATES_OF',
        cities: []
      },
      {
        code: 'NR',
        name: 'NAURU',
        cities: []
      },
      {
        code: 'NC',
        name: 'NEW_CALEDONIA',
        cities: []
      },
      {
        code: 'NZ',
        name: 'NEW_ZEALAND',
        cities: []
      },
      {
        code: 'NU',
        name: 'NIUE',
        cities: []
      },
      {
        code: 'NF',
        name: 'NORFOLK_ISLAND',
        cities: []
      },
      {
        code: 'MP',
        name: 'NORTHERN_MARIANA_ISLANDS',
        cities: []
      },
      {
        code: 'PW',
        name: 'PALAU',
        cities: []
      },
      {
        code: 'PG',
        name: 'PAPUA_NEW_GUINEA',
        cities: []
      },
      {
        code: 'PN',
        name: 'PITCAIRN',
        cities: []
      },
      {
        code: 'WS',
        name: 'SAMOA',
        cities: []
      },
      {
        code: 'SB',
        name: 'SOLOMON_ISLANDS',
        cities: []
      },
      {
        code: 'TK',
        name: 'TOKELAU',
        cities: []
      },
      {
        code: 'TO',
        name: 'TONGA',
        cities: []
      },
      {
        code: 'TV',
        name: 'TUVALU',
        cities: []
      },
      {
        code: 'UM',
        name: 'UNITED_STATES_MINOR_OUTLYING_ISLANDS',
        cities: []
      },
      {
        code: 'VU',
        name: 'VANUATU',
        cities: []
      },
    ],
  },
  {
    code: 'AFR',
    name: 'AFRICA',
    countries: [
      {
        code: 'DZ',
        name: 'ALGERIA',
        cities: []
      },
      {
        code: 'AO',
        name: 'ANGOLA',
        cities: []
      },
      {
        code: 'BJ',
        name: 'BENIN',
        cities: []
      },
      {
        code: 'BW',
        name: 'BOTSWANA',
        cities: []
      },
      {
        code: 'BF',
        name: 'BURKINA_FASO',
        cities: []
      },
      {
        code: 'BI',
        name: 'BURUNDI',
        cities: []
      },
      {
        code: 'CM',
        name: 'CAMEROON',
        cities: []
      },
      {
        code: 'CV',
        name: 'CAPE_VERDE',
        cities: []
      },
      {
        code: 'CF',
        name: 'CENTRAL_AFRICAN_REPUBLIC',
        cities: []
      },
      {
        code: 'TD',
        name: 'CHAD',
        cities: []
      },
      {
        code: 'KM',
        name: 'COMOROS',
        cities: []
      },
      {
        code: 'CG',
        name: 'CONGO',
        cities: []
      },
      {
        code: 'CI',
        name: 'COTE_D_IVOIRE',
        cities: []
      },
      {
        code: 'CD',
        name: 'DEMOCRATIC_REPUBLIC_OF_THE_CONGO',
        cities: []
      },
      {
        code: 'DJ',
        name: 'DJIBOUTI',
        cities: []
      },
      {
        code: 'EG',
        name: 'EGYPT',
        cities: []
      },
      {
        code: 'GQ',
        name: 'EQUATORIAL_GUINEA',
        cities: []
      },
      {
        code: 'ER',
        name: 'ERITREA',
        cities: []
      },
      {
        code: 'ET',
        name: 'ETHIOPIA',
        cities: []
      },
      {
        code: 'GA',
        name: 'GABON',
        cities: []
      },
      {
        code: 'GM',
        name: 'GAMBIA',
        cities: []
      },
      {
        code: 'GH',
        name: 'GHANA',
        cities: []
      },
      {
        code: 'GN',
        name: 'GUINEA',
        cities: []
      },
      {
        code: 'GW',
        name: 'GUINEA-BISSAU',
        cities: []
      },
      {
        code: 'KE',
        name: 'KENYA',
        cities: []
      },
      {
        code: 'LS',
        name: 'LESOTHO',
        cities: []
      },
      {
        code: 'LR',
        name: 'LIBERIA',
        cities: []
      },
      {
        code: 'LY',
        name: 'LIBYA',
        cities: []
      },
      {
        code: 'MG',
        name: 'MADAGASCAR',
        cities: []
      },
      {
        code: 'MW',
        name: 'MALAWI',
        cities: []
      },
      {
        code: 'ML',
        name: 'MALI',
        cities: []
      },
      {
        code: 'MR',
        name: 'MAURITANIA',
        cities: []
      },
      {
        code: 'MU',
        name: 'MAURITIUS',
        cities: []
      },
      {
        code: 'YT',
        name: 'MAYOTTE',
        cities: []
      },
      {
        code: 'MA',
        name: 'MOROCCO',
        cities: []
      },
      {
        code: 'MZ',
        name: 'MOZAMBIQUE',
        cities: []
      },
      {
        code: 'NA',
        name: 'NAMIBIA',
        cities: []
      },
      {
        code: 'NE',
        name: 'NIGER',
        cities: []
      },
      {
        code: 'NG',
        name: 'NIGERIA',
        cities: []
      },
      {
        code: 'RW',
        name: 'RWANDA',
        cities: []
      },
      {
        code: 'RE',
        name: 'RÉUNION',
        cities: []
      },
      {
        code: 'SH',
        name: 'SAINT_HELENA',
        cities: []
      },
      {
        code: 'ST',
        name: 'SAO_TOME_AND_PRINCIPE',
        cities: []
      },
      {
        code: 'SN',
        name: 'SENEGAL',
        cities: []
      },
      {
        code: 'SC',
        name: 'SEYCHELLES',
        cities: []
      },
      {
        code: 'SL',
        name: 'SIERRA_LEONE',
        cities: []
      },
      {
        code: 'SO',
        name: 'SOMALIA',
        cities: []
      },
      {
        code: 'ZA',
        name: 'SOUTH_AFRICA',
        cities: []
      },
      {
        code: 'SS',
        name: 'SOUTH_SUDAN',
        cities: []
      },
      {
        code: 'SD',
        name: 'SUDAN',
        cities: []
      },
      {
        code: 'SZ',
        name: 'SWAZILAND',
        cities: []
      },
      {
        code: 'TZ',
        name: 'TANZANIA',
        cities: []
      },
      {
        code: 'TG',
        name: 'TOGO',
        cities: []
      },
      {
        code: 'TN',
        name: 'TUNISIA',
        cities: []
      },
      {
        code: 'UG',
        name: 'UGANDA',
        cities: []
      },
      {
        code: 'EH',
        name: 'WESTERN_SAHARA',
        cities: []
      },
      {
        code: 'ZM',
        name: 'ZAMBIA',
        cities: []
      },
      {
        code: 'ZW',
        name: 'ZIMBABWE',
        cities: []
      },
    ],
  },
  {
    code: 'SAM',
    name: 'SOUTH_AMERICA',
    countries: [
      {
        code: 'AR',
        name: 'ARGENTINA',
        cities: []
      },
      {
        code: 'BO',
        name: 'BOLIVIA',
        cities: []
      },
      {
        code: 'BR',
        name: 'BRAZIL',
        cities: []
      },
      {
        code: 'CL',
        name: 'CHILE',
        cities: []
      },
      {
        code: 'CO',
        name: 'COLOMBIA',
        cities: []
      },
      {
        code: 'EC',
        name: 'ECUADOR',
        cities: []
      },
      {
        code: 'FK',
        name: 'FALKLAND_ISLANDS_(MALVINAS)',
        cities: []
      },
      {
        code: 'GF',
        name: 'FRENCH_GUIANA',
        cities: []
      },
      {
        code: 'GY',
        name: 'GUYANA',
        cities: []
      },
      {
        code: 'PY',
        name: 'PARAGUAY',
        cities: []
      },
      {
        code: 'PE',
        name: 'PERU',
        cities: []
      },
      {
        code: 'SR',
        name: 'SURINAME',
        cities: []
      },
      {
        code: 'UY',
        name: 'URUGUAY',
        cities: []
      },
      {
        code: 'VE',
        name: 'VENEZUELA',
        cities: []
      },
    ],
  },
];

// Wenn du die alte countries-Array-Struktur noch brauchst, kannst du sie so erstellen:
// export const countries: Country[] = continents.flatMap(
//   (continent) => continent.countries
// );
